import { AxiosResponse } from 'axios';
import axiosServices from '../utils/axios';
import { QueryMethod } from './utils';
import type { BaseError, FetchParams, ValidationError } from './types';

export * from './types';

export const API_URL = process.env.REACT_APP_API_URL;
export const PREFIX_BACKEND_PATH = process.env.REACT_APP_PREFIX_BACKEND_PATH || '/api/platform';

export async function fetch<T>(
  path: string,
  method: QueryMethod,
  data: any = null,
  params?: FetchParams,
  configs?: any,
): Promise<T> {
  try {
    const response: AxiosResponse<T, ValidationError | BaseError> = await axiosServices({
      url: API_URL + PREFIX_BACKEND_PATH + path,
      method: method,
      data: data,
      params,
      ...configs,
    });

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
}
